import { render, staticRenderFns } from "./DraftProduk.vue?vue&type=template&id=cd957808&scoped=true&"
import script from "./DraftProduk.vue?vue&type=script&lang=js&"
export * from "./DraftProduk.vue?vue&type=script&lang=js&"
import style0 from "./DraftProduk.vue?vue&type=style&index=0&id=cd957808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd957808",
  null
  
)

export default component.exports